<cac-dialog-layout
  [title]="'Create Wallet Transaction'"
  [subtitle]="'Create a wallet transaction for ' + customerName"
  (onSubmit)="onSubmit($event)"
>
  <div class="p-4">
    <cac-form-builder [options]="form"></cac-form-builder>
  </div>
</cac-dialog-layout>
